import { AlignmentType, LevelFormat, TabStopType } from "docx";

const defaultFontNormal = {
  font: "Arial",
  // default is size: 18
};

const georgia = {
  font: "Georgia",
};

const defaultFontBold = {
  font: "Arial",
  bold: true,
};

const defaultFontItalic = {
  font: "Arial",
  italics: true,
};

const greyColour = {
  fill: "D9D9D9",
  type: "clear",
};

const blueColour = "#0000FF";
const orangeColour = "#d04A02";

// table formatting
const tableCellsMargins = { top: 100, bottom: 100, left: 100, right: 100 };
const cellSize = 20;
const cellTextSize = 20;

const indentationNormal = {
  indent: {
    left: 360,
  },
};

const indentationLevel1 = {
  indent: {
    left: 1000,
  },
};

const smallFontSize = {
  size: 16,
};

const bigFontSize = {
  size: 48,
};

const mediumFontSize = {
  size: 40,
};

const rightTabStop = {
  type: TabStopType.RIGHT,
  position: 9000,
};

const headerTitleStyle = {
  ...defaultFontNormal,
  ...bigFontSize,
  color: orangeColour,
};

const numberingStyle = {
  level: 0,
  format: LevelFormat.DECIMAL,
  text: "%1.",
  alignment: AlignmentType.LEFT,
  style: {
    paragraph: {
      indent: { left: 720, hanging: 360 },
    },
    run: {
      font: "Arial",
    },
  },
};

const tableOfContentsStyle = {
  id: "TOC1",
  name: "TOC 1",
  basedOn: "Normal",
  next: "Normal",
  quickFormat: true,
  run: {
    font: "Arial",
    bold: true,
    size: 20,
  },
  paragraph: {
    spacing: { after: 120 },
  },
};

export {
  bigFontSize,
  blueColour,
  cellSize,
  cellTextSize,
  defaultFontBold,
  defaultFontItalic,
  defaultFontNormal,
  georgia,
  greyColour,
  headerTitleStyle,
  indentationLevel1,
  indentationNormal,
  mediumFontSize,
  numberingStyle,
  orangeColour,
  rightTabStop,
  smallFontSize,
  tableCellsMargins,
  tableOfContentsStyle,
};
